import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { cloneDeep, filter, get, indexOf } from 'lodash';
import { Subscriber } from 'rxjs';

import { ISite, SitesService } from '@nrwl/common-lib';

import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';
import { REMOVED } from '../../../services/base.wizard.step';
import { DatasourceWizardService } from '../../../services/datasource/datasource.wizard.service';

@Component({
  selector: 'datasource-site-selection-html',
  templateUrl: './datasource.site.selection.page.html',
  providers: [],
  styleUrls: [
    '../datasource.style.scss',
    './datasource.site.selection.scss',
    '../../../wizard.button.style.scss'
  ]
})
export class DatasourceSiteSelectionComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  @Input() previousOutput: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm', { static: true }) form: NgForm;

  siteList: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  selectedSiteId: any; //eslint-disable-line @typescript-eslint/no-explicit-any

  selectedLocationName: string;
  selectedSiteName: string;
  location: string;
  point: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  subscription: Subscriber<any>; //eslint-disable-line @typescript-eslint/no-explicit-any
  type: any; //eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(
    private wizardService: DatasourceWizardService,
    private readonly sitesService: SitesService
  ) {}

  ngOnInit() {
    this.step.form = this.form;
    this.getAllSites();
    this.selectedSiteId = 0;
    this.selectedLocationName = '';
    this.selectedSiteName = '';
    this.type = this.step.parent.output.type;
    this.repopulateSiteInfo();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  filterSiteData(sites: any): any {
    const filterIds = ['Private', 'Public']; //filtering public and private names
    return filter(sites, site => indexOf(filterIds, site.name) === -1);
  }

  getAllSites(): void {
    const sites = this.sitesService.getActiveSites();
    this.step.dataSource = this.filterSiteData(sites);
    this.siteList = cloneDeep(this.step.dataSource);
  }

  chooseSite(site: ISite): void {
    this.selectedSiteId = site.id;
    this.selectedSiteName = site.name;
    this.selectedLocationName = site.locationname;
    this.point = {
      latitude: get(site, 'location.lat', ''),
      longitude: get(site, 'location.lon', '')
    };
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'siteIdInput',
      key: 'siteId',
      newValue: this.selectedSiteId,
      isValid: true
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'siteInput',
      key: 'site',
      newValue: this.selectedSiteId,
      isValid: true
    });

    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'siteNameInput',
      key: 'siteName',
      newValue: this.selectedSiteName,
      isValid: true
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'locationNameInput',
      key: 'locationName',
      newValue: this.selectedLocationName,
      isValid: true
    });
    if (this.type === 'GigaTestAgent' && !this.wizardService.editMode) {
      this.onDataValueChange.emit({
        componentId: this.componentId,
        inputId: 'locationInput',
        key: 'location',
        newValue: this.selectedSiteId,
        isValid: true
      });
      this.onDataValueChange.emit({
        componentId: this.componentId,
        inputId: 'pointInput',
        key: 'point',
        newValue: this.point,
        isValid: true
      });
      this.onDataValueChange.emit({
        componentId: this.componentId,
        inputId: 'typeInput',
        key: 'type',
        newValue: 'ONGOING',
        isValid: true
      });
    }
  }

  resetSelectedSiteInformation(): void {
    this.selectedSiteId = 0;
    this.selectedLocationName = '';
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'siteInput',
      key: 'site',
      newValue: REMOVED,
      isValid: false
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'siteIdInput',
      key: 'siteId',
      newValue: REMOVED,
      isValid: false
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'locationNameInput',
      key: 'locationName',
      newValue: REMOVED,
      isValid: true
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'siteNameInput',
      key: 'siteName',
      newValue: REMOVED,
      isValid: false
    });
    if (this.type === 'GigaTestAgent') {
      this.onDataValueChange.emit({
        componentId: this.componentId,
        inputId: 'locationInput',
        key: 'location',
        newValue: REMOVED,
        isValid: true
      });
      this.onDataValueChange.emit({
        componentId: this.componentId,
        inputId: 'pointInput',
        key: 'point',
        newValue: REMOVED,
        isValid: true
      });
    }
  }

  repopulateSiteInfo(): void {
    const prevSiteId = get(this.previousOutput, 'siteId', null);
    if (this.wizardService.editMode && prevSiteId) {
      this.selectedSiteId = prevSiteId;
      this.selectedLocationName = get(this.previousOutput, 'locationName');
      this.selectedSiteName = get(this.previousOutput, 'siteName');
    } else {
      const host = this.stateHistory(this.componentId, 'siteIdInput');
      if (host && host.value && host.value !== REMOVED) {
        this.selectedSiteId = host.value;
      }
      const locationName = this.stateHistory(this.componentId, 'locationNameInput');
      if (locationName && locationName.value && locationName.value !== REMOVED) {
        this.selectedLocationName = locationName.value;
      }
      const siteName = this.stateHistory(this.componentId, 'siteNameInput');
      if (siteName && siteName.value && siteName.value !== REMOVED) {
        this.selectedSiteName = siteName.value;
      }
    }
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSearchTextChange(searchText: string): any {
    searchText = searchText.toLowerCase();
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.step.dataSource = filter(this.siteList, (item: any) => {
      if (
        item.name.toLowerCase().indexOf(searchText) >= 0 ||
        item.locationname.toLowerCase().indexOf(searchText) >= 0
      ) {
        return item;
      }
    });
  }
}
